import { render } from "./ModalsPage.vue?vue&type=template&id=009ac442&ts=true"
import script from "./ModalsPage.vue?vue&type=script&lang=ts"
export * from "./ModalsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__